import axios from "axios";
import { BASE_API } from "../../constants/api";

const axiosHttp = axios.create({
  baseURL: `${BASE_API}`,
});


axiosHttp.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if(token){
      return {
        ...config,
        headers: {
          ...(token !== null && { Authorization: `Bearer ${token}`}),
          ...config.headers,
        },
      };
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosHttp.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      //(`unauthorized :)`);
      //localStorage.removeItem("persist:root");
      //removeLocalStorageToken
      //window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosHttp;